/**
 * Rewards V2 - Smile.io Link Interceptor
 * Prevents #smile-home links from causing full page refresh.
 * Instead, opens the Smile.io launcher popup directly.
 * Only runs on the rewards page template (loaded conditionally).
 */
(function() {
  'use strict';

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="#smile-home"], a[href*="#smile"]');
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();

    // Method 1: Use official Smile UI JS API
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      window.SmileUI.openPanel();
      return;
    }

    // Method 2: Click the Smile launcher iframe (full or lite) container
    var launcher = document.querySelector('#smile-ui-lite-launcher-frame-container, #smile-ui-container, .smile-launcher-frame');
    if (launcher) {
      launcher.click();
      var clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      launcher.dispatchEvent(clickEvent);
    }

    // Method 3: Use Smile SDK if available
    if (typeof window.loadSmileSdk === 'function') {
      try { window.loadSmileSdk(); } catch(err) {}
    }

    // Method 4: Try to post message to iframe
    var iframe = document.querySelector('iframe[id*="smile"]');
    if (iframe && iframe.contentWindow) {
      try {
        iframe.contentWindow.postMessage({ type: 'smile:open' }, '*');
      } catch(err) {}
    }
  }, true);
})();
